module.exports = __webpack_public_path__ + "media/images/room_menu_icon/room_monitors-41af46715945bcaf67acd427b51e5a83.png";